module.exports = __webpack_public_path__ + "img/case.ec886283.jpg";